import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useQuery } from "react-query";
import useApi from "../../hooks/useApi";
import useApp from "../../hooks/useApp";
import { FilterBar } from "../../widgets";
import {
  Accordion,
  Button,
  Modal,
  Container,
  Form,
  InputGroup,
  Row,
  Col,
  Tab,
  Tabs,
} from "react-bootstrap";

const ClaimView = () => {
  const { claimId } = useParams();
  const { api, abortSignal, auth } = useApi();
  const { showAlert } = useApp();

  const getClaim = async () => {
    try {
      if (claimId) {
        const { data = {} } = await api.read(`/claims/${claimId}`);
        return data;
      }
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: claim } = useQuery(["claim", claimId, auth], ({ queryKey }) =>
    getClaim()
  );

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed overlapping">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/claims">Claims</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                View
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}

          <h1 className="page-title mb-0 mt-2">Claims Details</h1>

          <p className="lead">View claim details</p>

          <div className="d-md-flex align-items-baseline my-3">
            {/* <Link to="/claims/add" className="btn btn-info hstack gap-2 mb-3">
              <i className="demo-psi-add fs-4"></i>
              <span className="vr"></span>
              Add Claim
            </Link> */}
            <FilterBar />
          </div>
        </div>
      </div>
      <div className="content__boxed">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-7">
              <Accordion defaultActiveKey="1" className="mb-1">
                {/* <Accordion.Item eventKey="0">
                  <Accordion.Header>Policy details</Accordion.Header>
                  <Accordion.Body></Accordion.Body>
                </Accordion.Item> */}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Claim Requirements</Accordion.Header>
                  <Accordion.Body>
                    {/* <ClientPolicyRequirement policy={policy} /> */}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="col-lg-5">
              <Accordion defaultActiveKey="0" className="mb-1">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Policy details</Accordion.Header>
                  <Accordion.Body></Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClaimView;
